import { Routes } from '@angular/router';
import { FrontAuthGuard } from './core/guards/front-auth.guards';
import { BackAuthGuard } from './core/guards/back-auth.guards';
import { DevGuard } from './core/guards/dev.guard';
import { FrontLayoutComponent } from './layout/front-layout/front-layout.component';
import { LoginLayoutComponent } from './layout/login-layout/login-layout.component';
import { ParametersComponent } from './features/front/parameters/parameters/parameters.component';

export const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'authentication',
    },
    {
        path: 'authentication',
        component: LoginLayoutComponent,
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'login'
            },
            {
                path: 'login',
                loadComponent: () =>
                import('./features/authentication/login/login.component').then(
                (mod) => mod.LoginComponent)
            },
            {
                path: 'register',
                loadComponent: () =>
                import('./features/authentication/register/register.component').then(
                (mod) => mod.RegisterComponent)
            },
            {
                path: 'request-new-password',
                loadComponent: () =>
                  import('./features/authentication/request-new-password/request-new-password.component').then(
                    (mod) => mod.RequestNewPasswordComponent
                  )
              },
              {
                path: 'forgotPassword',
                loadComponent: () =>
                  import('./features/authentication/lost-password/lost-password.component').then(
                    (mod) => mod.LostPasswordComponent
                  )
              }
        ]
    },
    {
        path: 'help',
                loadComponent: () =>
                import('./shared/components/guide/guide.component').then(
                (mod) => mod.GuideComponent),
    },
    {
        path: 'front',
        component: FrontLayoutComponent,
        canActivate: [FrontAuthGuard],
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'dashboard'
            },
            {
                path: 'dashboard',
                loadComponent: () =>
                import('./features/front/dashboard/dashboard.component').then(
                (mod) => mod.DashboardComponent),

            },
            
            {
                path: 'operation',
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import('./features/front/operation/operation.component').then(
                            (mod) => mod.OperationComponent
                        )
                    },
                    {
                        path: 'search',
                        loadComponent: () =>
                            import('./features/front/search-operation/search-operation.component').then(
                            (mod) => mod.SearchOperationComponent
                        )
                    },
                    {
                        path: 'average-budget',
                        loadComponent: () =>
                            import('./features/front/average-budget/average-budget.component').then(
                            (mod) => mod.AverageBudgetComponent
                        )
                    }
                ]
            },
            {
                path: 'previsionnel',
                children: [
                  {
                    path: 'operations',
                    loadComponent: () =>
                      import('./features/front/previsionnel/budget-previsionnel/echeance/echeance.component').then(
                        (mod) => mod.EcheanceComponent
                      )
                  },
                  {
                    path: 'budget/details',
                    loadComponent: () =>
                      import('./features/front/previsionnel/budget-previsionnel/budget-previsionnel.component').then(
                        (mod) => mod.BudgetPrevisionnelComponent
                      )
                  },
                  {
                    path: 'month',
                    loadComponent: () =>
                        import('./features/front/previsionnel/budget-previsionnel/upcoming-deadlines/upcoming-deadlines.component').then(
                            (mod) => mod.UpcomingDeadlinesComponent
                          )
                  },
                  {
                    path: 'budget/echeances',
                    loadComponent: () =>
                        import('./features/front/previsionnel/budget-previsionnel/echeance-list/echeance-list.component').then(
                        (mod) => mod.EcheanceListComponent
                        )
                    },
                  {
                    path: 'difftable',
                    loadComponent: () =>
                        import('./features/front/previsionnel/difftable/difftable.component').then(
                            (mod) => mod.DifftableComponent
                          )
                  },
                  {
                    path: 'statement',
                    loadComponent: () =>
                      import('./features/front/previsionnel/statement/statement.component').then(
                        (mod) => mod.StatementTableComponent
                      )
                  }
                ]
              },
              {
                path: 'indicator',

                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import('./features/front/indicator/category-analysis/category-analysis.component').then(
                            (mod) => mod.CategoryAnalysisComponent)
                    },
                    {
                        path: 'analysis',
                        loadComponent: () =>
                            import('./features/front/indicator/category-analysis/category-analysis.component').then(
                            (mod) => mod.CategoryAnalysisComponent)
                    },
                    {
                        path: 'pat',
                        loadComponent: () =>
                            import('./features/front/indicator/patrimony/patrimony.component').then(
                            (mod) => mod.PatrimonyComponent)
                    }
                            ]
                
            },
            {
                path: 'diagnostic',
                canActivate: [DevGuard],
                loadComponent: () =>
                import('./features/front/diagnostic/diagnostic.component').then(
                (mod) => mod.DiagnosticComponent)
            },
            {
                path: 'help',
                loadComponent: () =>
                import('./features/front/help-page/help-page.component').then(
                (mod) => mod.HelpPageComponent)
            },
           
            {
                path: 'parameters',
                children: [
                    {
                        path: '',
                        component: ParametersComponent
                    },
                    {
                        path: 'account-info',
                        loadComponent: () =>
                        import('./features/front/parameters/account-info/account-info.component').then(
                        (mod) => mod.AccountInfoComponent)
                    },
                    {
                        path: 'accounts',
                        loadComponent: () =>
                        import('./features/front/parameters/accounts/accounts.component').then(
                        (mod) => mod.AccountsComponent)
                    },
                    {
                        path: 'tags',
                        loadComponent: () =>
                        import('./features/front/parameters/tags/tags.component').then(
                        (mod) => mod.TagsComponent)
                    },
                    {
                        path: 'payees',
                        loadComponent: () =>
                        import('./features/front/parameters/payees/payees.component').then(
                        (mod) => mod.PayeesComponent)
                    },
                    {
                        path: 'import-presentation',
                        loadComponent: () =>
                        import('./features/front/parameters/import-presentation/import-presentation.component').then(
                        (mod) => mod.ImportPresentationComponent)
                    },
                    {
                        path: 'import',
                        loadComponent: () =>
                        import('./features/front/parameters/import/import.component').then(
                        (mod) => mod.ImportComponent)
                    },
                    {
                        path: 'budgets',
                        loadComponent: () =>
                        import('./features/front/parameters/budgets/budgets.component').then(
                        (mod) => mod.BudgetsComponent)
                    },
                    {
                        path: 'operations',
                        loadComponent: () =>
                        import('./features/front/parameters/operations/operations.component').then(
                        (mod) => mod.OperationsComponent)
                    },
                    {
                        path: 'categories',
                        loadComponent: () =>
                        import('./features/front/parameters/categories/categories.component').then(
                        (mod) => mod.CategoriesComponent)
                    }
                ]
            }
        ]
    },
    {
        path: 'admin',
        component: FrontLayoutComponent,
        canActivate: [BackAuthGuard],
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'admin-index'
            },
            {
                path: 'admin-index',
                loadComponent: () =>
                import('./features/admin/admin-index/admin-index.component').then(
                (mod) => mod.AdminIndexComponent)
            },
            {
                path: 'bons-plans',
                loadComponent: () =>
                import('./features/admin/bons-plans/bons-plans.component').then(
                (mod) => mod.BonsPlansComponent)
            },
            {
                path: 'users',
                loadComponent: () =>
                import('./features/admin/users/users.component').then(
                (mod) => mod.UsersComponent)
            },
            {
                path: 'versions',
                loadComponent: () =>
                import('./features/admin/versions/versions.component').then(
                (mod) => mod.VersionsComponent)
            },
            {
                path: 'cgu',
                loadComponent: () =>
                import('./features/admin/cgu/cgu.component').then(
                (mod) => mod.CguComponent)
            }
        ]
    }
];